import { GalaxyColumnDef } from '@vendasta/galaxy/table';

export type ItemPricingTableColumnID =
  | 'name'
  | 'quantity'
  | 'wholesale_price'
  | 'retail_price'
  | 'retail_price_total'
  | 'menu';

export const ITEM_PRICING_TABLE_COLUMNS: GalaxyColumnDef[] = [
  {
    id: 'name',
    title: 'Name',
  },
  {
    id: 'quantity',
    title: 'Quantity',
  },
  {
    id: 'wholesale_price',
    title: 'Wholesale',
  },
  {
    id: 'retail_price',
    title: 'Retail',
  },
  {
    id: 'retail_price_total',
    title: 'Retail Total',
  },
  {
    id: 'menu',
    title: 'Menu',
  },
];
